import React from 'react';
import { useDispatch } from 'react-redux';
import { AI_CHATBOT_STATUS } from '../../../constants/aiChatbot';
import { ChatbotIcon } from '../../icons/ChatbotIcon';
import { StarIcon } from '../../icons/StarIcon';
import styles from './StartButton.module.scss';
import { adjustAiChatbotStatus } from '../../../store/actions/aiChatbot';

export function StartButton() {
  const dispatch = useDispatch();

  const openWidget = () => dispatch(adjustAiChatbotStatus(AI_CHATBOT_STATUS.ON));

  return (
    <div role="button" className={styles.container} onClick={openWidget}>
      <div className={styles.content}>
        <div className={styles.chatbotIconContainer}>
          <ChatbotIcon />
        </div>
        Ask Cymbot
        <div className={styles.starIconContainer}>
          <StarIcon />
        </div>
      </div>
    </div>
  );
}
